import { Reveal, ChapterHead } from "./shared";

const FOUNDERS = [
  { name: "Daksh", phone: "+91 7733011368", tel: "+917733011368", testid: "founder-card-daksh" },
  { name: "Shivam", phone: "+91 8076601010", tel: "+918076601010", testid: "founder-card-shivam" },
];

export default function Story() {
  return (
    <section id="story" className="py-20 lg:py-32 bg-[#F4F0E6]/50" data-testid="story-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-14 lg:gap-20">
        <div className="lg:col-span-6">
          <ChapterHead number="09" label="Our Story" title="About ELYNCOR ELEMENTS" testid="story" />
          <Reveal delay={0.15}>
            <p className="mt-8 text-base sm:text-lg text-[#1A201C]/70 leading-relaxed" data-testid="story-text">
              ELYNCOR ELEMENTS brings together nature, craftsmanship and meaningful
              design to create decorative pieces inspired by natural materials and
              timeless symbolism.
            </p>
            <p className="mt-5 text-base sm:text-lg text-[#1A201C]/70 leading-relaxed" data-testid="story-founders-text">
              Founded by Daksh and Shivam, ELYNCOR ELEMENTS is built around the idea
              that everyday objects can carry both visual beauty and personal meaning.
            </p>
            <p className="font-hand text-2xl text-[#8C7A56]/80 mt-10" data-testid="story-signature">
              nature · energy · harmony
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-6 flex flex-col justify-center gap-5">
          {FOUNDERS.map((f, i) => (
            <Reveal key={f.name} delay={i * 0.12}>
              <div
                className="flex items-center justify-between border border-[#1B1915]/12 bg-[#FDFBF7] rounded-sm px-8 py-7 hover:-translate-y-1 transition-transform duration-500"
                data-testid={f.testid}
              >
                <div>
                  <p className="text-[11px] tracking-[0.24em] uppercase text-[#8C7A56]/70 mb-1">
                    Founder
                  </p>
                  <p className="font-serif-display text-2xl text-[#1B1915] tracking-tight">{f.name}</p>
                </div>
                <a
                  href={`tel:${f.tel}`}
                  className="text-sm text-[#2C2822] hover:text-[#1B1915] transition-colors duration-300 tracking-wide"
                  data-testid={`${f.testid}-phone`}
                >
                  {f.phone}
                </a>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
